/* jshint loopfunc: true */
/* globals google, MarkerClusterer, jQuery, wp_ajax, location_map_settings */



/**
 * JS function for initializing a location map based on Location CPT data.
 * Map utilized Google Maps and MarkerClusterer plugin to display all Darigold
 * locations on the front end of the site. Locations can be filtered based on
 * region and type taxonomies.
 */

module.exports = (function($) {

    var MarkerClusterer = require("@google/markerclusterer")
    var OverlappingMarkerSpiderfier = require('overlapping-marker-spiderfier');

    /**
     * Sets up initial values and event handlers for location map functionality.
     * @param HTMLElement mapElement        The element which will contain the location map
     * @param HTMLElement filterFormElement The filter form element
     */
    var WineryMap = function(mapElement, filterFormElement, listElement) {
      var self = this;

      // Map Properties
      this.isLoading = true;

      this.initialCenter = new google.maps.LatLng(46.0610921, -118.3425147);
      this.initialZoom = 12;
      this.maxZoom = 18;
      this.mapElement = mapElement;
      this.map = null;
      this.oms = null;
      this.locations = [];
      this.locationMarkers = [];
      this.locationInfoWindow = new google.maps.InfoWindow();
    //   this.mapStyles = [ { "featureType": "administrative", "elementType": "all", "stylers": [ { "saturation": "-100" } ] }, { "featureType": "administrative.province", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 65 }, { "visibility": "on" }, { "color": "#fdfbf2" } ] }, { "featureType": "poi", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": "50" }, { "visibility": "off" } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f3edd9" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": "-100" } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "road.arterial", "elementType": "all", "stylers": [ { "lightness": "30" } ] }, { "featureType": "road.local", "elementType": "all", "stylers": [ { "lightness": "40" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "saturation": -100 }, { "visibility": "simplified" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "visibility": "on" }, { "gamma": "1.34" } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "lightness": -25 }, { "saturation": -97 }, { "color": "#80a1b6" } ] }, { "featureType": "water", "elementType": "labels", "stylers": [ { "lightness": -25 }, { "saturation": -100 } ] } ];
      this.mapStyles = [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"},{"color":"#faf9f8"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#e7e7e6"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"gamma":"1.34"}]},{"featureType":"water","elementType":"geometry","stylers":[{"lightness":-25},{"saturation":-97},{"color":"#005e61"}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}];
      this.mapContainClass = 'section-locations-map';
      this.markerClusterer = null;
      this.markerClusterImageBase = null;

      // Filter Properties
      this.filterFormElement = filterFormElement;

      // Checkbox filter element groups
      this.regionFilterElements = this.filterFormElement.querySelectorAll('input[name="location-region"]');
      this.offeringFilterElements = this.filterFormElement.querySelectorAll('input[name="offering_types"]');
      this.accessibilityFilterElements = this.filterFormElement.querySelectorAll('input[name="accessibility_types"]');
      this.daysOpenFilterElements = this.filterFormElement.querySelectorAll('input[name="days_open_types"]');
      this.amenitiesFilterElements = this.filterFormElement.querySelectorAll('input[name="amenity_types"]');

      // Helper to get checked values for a group
      function getCheckedValues(elements) {
        var checked = Array.from(elements).filter(function(el){ return el.checked; });
        var values = checked.map(function(el){ return el.value; });
        if (values.length === 0) return ['*'];
        if (values.indexOf('*') !== -1) return ['*'];
        return values;
      }

      //List Properties
      this.listElement = listElement;

      // Add event listeners for all checkboxes
      [
        this.regionFilterElements,
        this.offeringFilterElements,
        this.accessibilityFilterElements,
        this.daysOpenFilterElements,
        this.amenitiesFilterElements
      ].forEach(function(group) {
        group.forEach(function(el) {
          el.addEventListener('change', function() {
            if (!self.isLoading) {
              var regions = getCheckedValues(self.regionFilterElements);
              var offerings = getCheckedValues(self.offeringFilterElements);
              var accessibility = getCheckedValues(self.accessibilityFilterElements);
              var daysOpen = getCheckedValues(self.daysOpenFilterElements);
              var amenities = getCheckedValues(self.amenitiesFilterElements);
              self.filterLocationMarkers(regions, offerings, accessibility, daysOpen, amenities);
            }
          });
        });
      });
    };

    /**
     * Initializes the Google map on the page and loads the location data to display
     */
    WineryMap.prototype.initMap = function(){

      var self = this;
      // Map arguments
      var args = {
        zoom:              this.initialZoom,
        maxZoom:           this.maxZoom,
        center:            this.initialCenter,
        mapTypeId:         google.maps.MapTypeId.ROADMAP,
        mapTypeControl:    false,
        rotateControl:     false,
        fullscreenControl: false,
        streetViewControl: false,
        styles:            this.mapStyles
      };

      // Create map and store it for future reference
      this.map = new google.maps.Map(this.mapElement, args);

      const options = { 
        nudgeStackedMarkers: false, 
        legWeight: 0,
        keepSpiderfied: true, 
        spiderfiedShadowColor: false

      };
      this.oms = new OverlappingMarkerSpiderfier(this.map, options);

      const iw = new google.maps.InfoWindow();
      this.oms.addListener('click', function(marker, event) {
        self.openInfoWindow(marker);
      });

      this.oms.addListener('spiderfy', function(markers) {
        iw.close();
      });

      // Load location data and populate the map
      this.getMapData();
    };

    /**
     * Filters the list of locations based on the given region and type,
     * and refreshes the markers displayed on the map based accordingly.
     *
     * @param int|string region The id of a region WP term to filter the list
     *                          based on, or '*' to include all regions
     * @param int|string offering   The id of a offering WP term to filter the list
     *                          based on, or '*' to include all types
     * @param int|string accessibility   The id of a accessibility WP term to filter the list
     *                          based on, or '*' to include all types
     */
    WineryMap.prototype.filterLocationMarkers = function(regions, offerings, accessibility, daysOpen, amenities){
      var filteredLocations = [];
      var allRegions = (Array.isArray(regions) && (regions.length === 0 || (regions.length === 1 && regions[0] === '*')));
      var allOfferings = (Array.isArray(offerings) && (offerings.length === 0 || (offerings.length === 1 && offerings[0] === '*')));
      var allAccessibility = (Array.isArray(accessibility) && (accessibility.length === 0 || (accessibility.length === 1 && accessibility[0] === '*')));
      var allDaysOpen = (Array.isArray(daysOpen) && (daysOpen.length === 0 || (daysOpen.length === 1 && daysOpen[0] === '*')));
      var allAmenities = (Array.isArray(amenities) && (amenities.length === 0 || (amenities.length === 1 && amenities[0] === '*')));

      if (allRegions && allOfferings && allAccessibility && allDaysOpen && allAmenities) {
        filteredLocations = this.locations;
      } else {
        // Convert to int for comparison
        var regionInts = (Array.isArray(regions) ? regions : [regions]).map(function(r){ return parseInt(r); });
        var offeringInts = (Array.isArray(offerings) ? offerings : [offerings]).map(function(o){ return parseInt(o); });
        var accessibilityInts = (Array.isArray(accessibility) ? accessibility : [accessibility]).map(function(a){ return parseInt(a); });
        var daysOpenInts = (Array.isArray(daysOpen) ? daysOpen : [daysOpen]).map(function(d){ return parseInt(d); });
        var amenitiesInts = (Array.isArray(amenities) ? amenities : [amenities]).map(function(a){ return parseInt(a); });
        filteredLocations = this.locations.filter(
          function(location){
            var regionMatch = allRegions || regionInts.some(function(rid){ return location.regionIds.indexOf(rid) > -1; });
            var offerMatch = allOfferings || offeringInts.some(function(oid){ return location.offeringIds.indexOf(oid) > -1; });
            var accessibilityMatch = allAccessibility || accessibilityInts.some(function(aid){ return location.accessibilityIds.indexOf(aid) > -1; });
            var daysOpenMatch = allDaysOpen || (location.daysOpenIds && daysOpenInts.some(function(did){ return location.daysOpenIds.indexOf(did) > -1; }));
            var amenitiesMatch = allAmenities || (location.amenitiesIds && amenitiesInts.some(function(aid){ return location.amenitiesIds.indexOf(aid) > -1; }));
            return regionMatch && offerMatch && accessibilityMatch && daysOpenMatch && amenitiesMatch;
          },
          this
        );
      }
      this.refreshMarkers(filteredLocations, true);
      this.refreshList(filteredLocations,true);
    };

    /**
     * Asynchronously pull the list of locations to display on the map,
     * and save them for future use. Also includes a base image path used
     * by the MarkerCluster plugin to display cluster images.
     */
    WineryMap.prototype.getMapData = function(){
      var self = this;

      // Get our data using AJAX
      $.ajax({
        type: 'POST',
        url: wp_ajax.url,
        data: {
          action: 'get_location_map_data'
        },
        // If response is successful, store the resulting data and refresh the displayed markers and list
        success: function(result) {
          self.locations = result.locations;
          self.markerClusterImageBase = result.markerClusterImageBase;
          //Get the query parameters
          //var urlParams = new URLSearchParams(window.location.search);
          //Check if the region is set
          if(self.urlParam('region') !== null){
            var regionName = self.urlParam('region');
            var regionExists = false;

            //Check if the region passed in the query string is in the regions dropdown
            for(var i = 0, opts = self.regionFilterElement.options; i < opts.length; ++i) {
              if( opts[i].text ==  regionName)
              {
                regionExists = true;
                regionValue = opts[i].value;
                break;
              }
            }
            //if they passed a region and its in the dropdown
            if(regionExists) {
              //update the region dropdown
              $("#"+self.regionFilterName).val(regionValue);
              //Get the region offering and accessibility options
              var region = self.regionFilterElement.value;
              var offering = self.offeringFilterElement.value;
              var accessibility = self.accessibilityFilterElement.value;
              //filter the map markers and dropdowns
              self.filterLocationMarkers(region, offering, accessibility);
              self.updateOfferingFilter(region, accessibility);
              self.updateAccessibilityFilter(region, offering);
            }else{
              self.refreshMarkers(self.locations, true);
              self.refreshList(self.locations,true);
            }
          } else if(self.urlParam('varietal') !== null) {
            var varietalName = self.urlParam('varietal');
            var varietalExists = false;

            //Check if the varietal passed in the query string is in the offerings dropdown
            for(var i = 0, opts = self.offeringFilterElement.options; i < opts.length; ++i) {
              if( opts[i].text ==  varietalName)
              {
                varietalExists = true;
                varietalValue = opts[i].value;
                break;
              }
            }
            //if they passed a varietal and its in the dropdown
            if(varietalExists) {
              //update the varietal dropdown
              $("#"+self.offeringFilterName).val(varietalValue);
              //Get the region offering and accessibility options
              var region = self.regionFilterElement.value;
              var offering = self.offeringFilterElement.value;
              var accessibility = self.accessibilityFilterElement.value;
              //filter the map markers and dropdowns
              self.filterLocationMarkers(region, offering, accessibility);
              self.updateOfferingFilter(region, accessibility);
              self.updateAccessibilityFilter(region, offering);
            }else{
              self.refreshMarkers(self.locations, true);
              self.refreshList(self.locations,true);
            }
          } else{
            self.refreshMarkers(self.locations, true);
            self.refreshList(self.locations,false);
          }
        },
        // TODO: Better error handling?
        error: function(xhr, status, err) {
          console.error(xhr, status, err);
        },
      }).always(function(){
          // The map is initially displayed with a loading animation, so
          // we need to turn it off once our data is retrieved.
        self.stopLoadingAnimation();
      });
    };

    WineryMap.prototype.urlParam = function(name){
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (results==null){
         return null;
      }
      else{
         return decodeURI(results[1]) || 0;
      }
    }

    /**
     * Refreshes the markers displayed on the map based on the provided
     * array of locations. Optionally fits the map viewport to the markers.
     *
     * @param object[] locations Array of location objects to display on the map
     * @param bool     fitBounds If the map viewport should be fit to the bounds of
     *                           these location markers
     */
    WineryMap.prototype.refreshMarkers = function(locations, fitBounds){
      var self = this;

      // If we already have a MarkerCluster, clear the markers from it
      if (this.markerClusterer) {
        this.markerClusterer.clearMarkers();
      }

      // Create markers for each location, as long as we have the required data
      var markers = [];
      for (var i = 0; i < locations.length; i++) {

        // Get location data
        var location = locations[i];
        var lat = location.coordinates.lat;
        var lng = location.coordinates.lng;
        var pinColor = location.pinColor;
        var popupContent = location.popupContent;

        if (lat && lng && pinColor) {
          var latLng = new google.maps.LatLng(lat,lng);
          var marker = new google.maps.Marker({
            position: latLng,
            icon: {
              path: "M528,290 C521.314286,290 516,295.27 516,301.9 C516,310.74 528,324 528,324 C528,324 540,310.74 540,301.9 C540,295.27 534.685714,290 528,290 L528,290 Z M528.5,306 C525.98,306 524,304.02 524,301.5 C524,298.98 525.98,297 528.5,297 C531.02,297 533,298.98 533,301.5 C533,304.02 531.02,306 528.5,306 L528.5,306 Z",
              fillColor: pinColor,
              anchor: new google.maps.Point(540, 324),
              fillOpacity: 1,
              strokeWeight: 0,

            }
          });

          // Open the InfoWindow when this marker is clicked
          marker.popupContent = popupContent;
          marker.locationName = location.name;
          // marker.addListener('click', function(){
          //   self.openInfoWindow(this);
          // });
          // Add new marker to our array
          markers.push(marker);
          self.oms.addMarker(marker);
        }
      }

      //Initialize the MarkerClusterer plugin with our location markers
      var mcOptions = {
        imagePath: this.markerClusterImageBase,
        maxZoom: this.maxZoom-1,
        styles:[{
          url: this.markerClusterImageBase+"1.png",
          width: 53,
          height:52,
          textColor:"white",
        }]

      };
      this.markerClusterer = new MarkerClusterer(
        this.map,
        markers,
        mcOptions
      );
      // Store our markers for future use
      this.locationMarkers = markers;
      // Optionally fit the map bounds to the markers
      if (fitBounds) {
        this.markerClusterer.fitMapToMarkers();
      }
    };
    //Refit Map to Markers
    WineryMap.prototype.fitMapToMarkers = function(){
      this.markerClusterer.fitMapToMarkers();
    }

    /**
     * Refreshes the markers displayed in the list based on the provided
     * array of locations.
     *
     * @param object[] locations Array of location objects to display on the map
     * @param boolean filtered Determines if this is a filtered list
     */
    WineryMap.prototype.refreshList = function(locations,filtered=false){
      $('#location-list .loc-link-card').remove();
      for (var i = 0; i < locations.length; i++) {

        var location = locations[i];
        var content = location.listItemContent;

        $('.grid-container').append(content);
        $('.grid-container').show();
      }
    };

    /**
     * Updates the available options for the type filter select based on
     * the specified region.
     *
     * @param int|string selectedRegion The id of the selected region WP term
     *                                  to filter the available offering options
     *                                  based on, or '*' to include all offering options
     * @param int|string selectedAccessibility The id of the selected Accessibility WP term
     *                                  to filter the available offering options
     *                                  based on, or '*' to include all offering options
     */
    WineryMap.prototype.updateOfferingFilter = function(selectedRegion, selectedAccessibility){
      var offeringFilterOptions = this.offeringFilterElement.getElementsByTagName('option');
      var getAllRegions = selectedRegion === '*';
      var getAllaccessibility = selectedAccessibility === '*';

      var enableAllOfferings = (getAllRegions && getAllaccessibility);

      // Enable all offering options
      if (enableAllOfferings) {
        for (var i = 0; i < offeringFilterOptions.length; i++) {
          offeringFilterOptions[i].disabled = false;
        }
      }
      else{
        // Get all offerings for the locations in the selected region and selected accessibility
        selectedRegion = parseInt(selectedRegion);
        selectedAccessibility = parseInt(selectedAccessibility);
        var offerings = this.locations.reduce(
          function(accumulator, location){
            if ((getAllRegions || location.regionIds.indexOf(selectedRegion) > -1) && (getAllaccessibility || location.accessibilityIds.indexOf(selectedAccessibility) > -1)) {
              return accumulator.concat(location.offeringIds);
            }
            return accumulator;
          },
          []
        );
        // Enable types for locations in the selected region, disable the rest
        for (var j = 0; j < offeringFilterOptions.length; j++) {
          var value = offeringFilterOptions[j].value;
          if (value === '*' || offerings.indexOf(parseInt(value)) > -1 ) {
            offeringFilterOptions[j].disabled = false;
          }
          else{
            offeringFilterOptions[j].disabled = true;
          }
        }
      }
    };

    /**
     * Updates the available options for the region filter select based on
     * the specified type.
     *
     * @param int|string selectedOffering The id of the selected offering WP term
     *                                to filter the available region options
     *                                based on, or '*' to include all region
     *                                options
     * @param int|string selectedAccessibility The id of the selected Accessibility WP term
     *                                to filter the available region options
     *                                based on, or '*' to include all region
     *                                options
     */
    WineryMap.prototype.updateRegionFilter = function(selectedOffering, selectedAccessibility){
      var regionFilterOptions = this.regionFilterElement.getElementsByTagName('option');
      var getAllOfferings = selectedOffering === '*';
      var getAllaccessibility = selectedAccessibility === '*';

      var enableAllRegions = (getAllOfferings && getAllaccessibility);

      // Enable all region options
      if (enableAllRegions) {
        for (var i = 0; i < regionFilterOptions.length; i++) {
          regionFilterOptions[i].disabled = false;
        }
      }
      else{
        // Get all region options based on the selected offerings and accessibility
        selectedOffering = parseInt(selectedOffering);
        selectedAccessibility = parseInt(selectedAccessibility);
        var regions = this.locations.reduce(
          function(accumulator, location){
            if ((getAllOfferings || location.offeringIds.indexOf(selectedOffering) > -1) && (getAllaccessibility || location.accessibilityIds.indexOf(selectedAccessibility) > -1)) {
              return accumulator.concat(location.regionIds);
            }
            return accumulator;
          },
          []
        );
        // Enable regions for locations in the selected type, disable the rest
        for (var j = 0; j < regionFilterOptions.length; j++) {
          var value = regionFilterOptions[j].value;
          if (value === '*' || regions.indexOf(parseInt(value)) > -1) {
            regionFilterOptions[j].disabled = false;
          }
          else{
            regionFilterOptions[j].disabled = true;
          }
        }
      }
    };

    /**
     * Updates the available options for the region filter select based on
     * the specified type.
     *
     * @param int|string selectedOffering The id of the selected offering WP term
     *                                to filter the available region options
     *                                based on, or '*' to include all region
     *                                options
     * @param int|string selectedAccessibility The id of the selected Accessibility WP term
     *                                to filter the available region options
     *                                based on, or '*' to include all region
     *                                options
     */
    WineryMap.prototype.updateAccessibilityFilter = function(selectedRegion, selectedOffering){
      var accessibilityFilterOptions = this.accessibilityFilterElement.getElementsByTagName('option');
      var getAllRegions = selectedRegion === '*';
      var getAllOfferings = selectedOffering === '*';

      var enableAllAccessibility = (getAllRegions && getAllOfferings);

      // Enable all region options
      if (enableAllAccessibility) {
        for (var i = 0; i < accessibilityFilterOptions.length; i++) {
          accessibilityFilterOptions[i].disabled = false;
        }
      }
      else{
        // Get all accessibility options based on the selected region and offerings
        selectedRegion = parseInt(selectedRegion);
        selectedOffering = parseInt(selectedOffering);
        var accessibility = this.locations.reduce(
          function(accumulator, location){
            if ((getAllOfferings || location.offeringIds.indexOf(selectedOffering) > -1) && (getAllRegions || location.regionIds.indexOf(selectedRegion) > -1)) {
              return accumulator.concat(location.accessibilityIds);
            }
            return accumulator;
          },
          []
        );

        // Enable regions for locations in the selected type, disable the rest
        for (var j = 0; j < accessibilityFilterOptions.length; j++) {
          var value = accessibilityFilterOptions[j].value;
          if (value === '*' || accessibility.indexOf(parseInt(value)) > -1 ) {
            accessibilityFilterOptions[j].disabled = false;
          }
          else{
            accessibilityFilterOptions[j].disabled = true;
          }
        }
      }
    };

    /**
     * Initializes the map loading state and animation
     */
    WineryMap.prototype.startLoadingAnimation = function(){
      $('.' + this.mapContainClass).addClass('loading');
      $('#' + this.regionFilterName + ', #' + this.offeringFilterName + ', #' + this.accessibilityFilterName).prop('disabled', true);

      this.isLoading = true;
    };

    /**
     * Turns off the map loading state and animation
     */
    WineryMap.prototype.stopLoadingAnimation = function(){
      $('.' + this.mapContainClass).removeClass('loading');
      $('#' + this.regionFilterName + ', #' + this.offeringFilterName+ ', #' + this.accessibilityFilterName).prop('disabled', false);
      this.isLoading = false;
    };

    /**
     * Opens a Google Maps InfoWindow for the specified marker.
     * Assumes the content for the InfoWindow is stored in the marker
     * object using a "popupContent" property, and the location name
     * is "locationName".
     *
     * @param google.maps.Marker marker The marker to dislay the InfoWindow
     *                                  for
     */
    WineryMap.prototype.openInfoWindow = function(marker){
      // Build content string with location name and popup content
      var content = marker.popupContent;

      // Set the InfoWindow content and open it
      this.locationInfoWindow.setContent(content);
      this.locationInfoWindow.setOptions({maxWidth:320});
      this.locationInfoWindow.open(this.map, marker);
    };

    // Return our WineryMap function so we can use it outside the current scope
    return WineryMap;
  })(jQuery);
